import PageWithSidebar from "components/PageWithSidebar";
import { Link, Route, Routes  } from "react-router";
import { DeveloperToolsRoute, RegisteredRoute } from "index";
import SideNav from "./SideNav";
import WebsocketTestClient from "./WebsocketTestClient";
import APIGWSelfService from "./APIGWSelfService";
import Editor from "./Editor";
import JsonYamlEditor from "./JsonYamlEditor";
import { Card, Container, Image } from "semantic-ui-react";
import { isDeveloperToolsUser } from "services/self";
import { NON_PROD } from "utils/constants";

function DeveloperTools() {
  return (
    <PageWithSidebar sidebarContent={<SideNav />}>
      <Routes>
        {NON_PROD && (
          <Route end
            path="/websocket-test-client"
            element={<RegisteredRoute><WebsocketTestClient/></RegisteredRoute>}
          />
        )}
        {NON_PROD && (
          <Route end
            path="/api-specification-editor"
            element={<DeveloperToolsRoute><Editor/></DeveloperToolsRoute>}
          />
        )}
        {NON_PROD && (
          <Route end
            path="/json-yaml-editor"
            element={<RegisteredRoute><JsonYamlEditor/></RegisteredRoute>}
          />
        )}
        {NON_PROD && (
          <Route
            path="/api-specification-editor/:apiType/:name"
            element={<DeveloperToolsRoute><Editor/></DeveloperToolsRoute>}
          />
        )}
        <Route 
          path="/api-gw-self-service"
          element={<DeveloperToolsRoute><APIGWSelfService/></DeveloperToolsRoute>}
        />
        <Route path="/" element={(
          <Container style={{ padding: "2em", width: "100%" }}>
            <Card.Group centered>
              {NON_PROD && (
                <Card as={Link} to="/developer-tools/websocket-test-client">
                  <Card.Content>
                    <Card.Header>WebSocket Test Client</Card.Header>
                    <Card.Description textAlign="center">
                      <Image
                        width="50"
                        height="50"
                        centered
                        src="/custom-content/test.png"
                      />
                    </Card.Description>
                    <Card.Description textAlign="center">
                      Click here to test the WebSocket API endpoints
                    </Card.Description>
                  </Card.Content>
                </Card>
              )}
              {isDeveloperToolsUser() && (
                <Card as={Link} to="/developer-tools/api-gw-self-service">
                  <Card.Content>
                    <Card.Header>API GW Self Serivce</Card.Header>
                    <Card.Description textAlign="center">
                      <Image
                        width="50"
                        height="50"
                        centered
                        src="/custom-content/self-service.png"
                      />
                    </Card.Description>
                    <Card.Description textAlign="center">
                      Click here to use the API GW Self Service to create, edit
                      and delete the endpoints
                    </Card.Description>
                  </Card.Content>
                </Card>
              )}
              {isDeveloperToolsUser() && NON_PROD && (
                <Card as={Link} to="/developer-tools/api-specification-editor">
                  <Card.Content>
                    <Card.Header>API Specification Editor</Card.Header>
                    <Card.Description textAlign="center">
                      <Image
                        width="50"
                        height="50"
                        centered
                        src="/custom-content/documentation.jpg"
                      />
                    </Card.Description>
                    <Card.Description textAlign="center">
                      Click here to edit and visualize Swagger and Async API
                      definitions
                    </Card.Description>
                  </Card.Content>
                </Card>
              )}
              {NON_PROD && (
                <Card as={Link} to="/developer-tools/json-yaml-editor">
                  <Card.Content>
                    <Card.Header>JSON/YAML Editor</Card.Header>
                    <Card.Description textAlign="center">
                      <Image
                        width="50"
                        height="50"
                        centered
                        src="/custom-content/documentation.jpg"
                      />
                    </Card.Description>
                    <Card.Description textAlign="center">
                      Click here to edit and validate JSON or YAML documents
                    </Card.Description>
                  </Card.Content>
                </Card>
              )}
            </Card.Group>
          </Container>
        )}/>
      </Routes>
    </PageWithSidebar>
  );
}

export default DeveloperTools;
